import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    rightContainer: {
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center"
    }
});
export default stylesheet;
